export const galControlWrapVariants = {
    initial: {

    }, animate: {
        transition: {
            staggerChildren: 0.2
        }
    }, exit: {
        transition: {
            staggerChildren: 0.2
        }
    }
}

export const galControlVariants = {
    initial: {
        opacity: 0,
        filter: "blur(5px)"
    }, animate: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
            duration: 1,
            ease: "easeIn"
        }
    }, exit: {
        opacity: 0,
        filter: "blur(5px)",
        transition: {
            duration: 1,
            ease: "easeOut"
        }
    } 
}